export default "__VITE_ASSET__dee17f61__"